import { createVanIconComponent } from "./van"

const PauseCircle = createVanIconComponent("pause-circle")
export default PauseCircle
